import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Form, Alert } from "react-bootstrap";
import { BsEye, BsEyeSlash } from "react-icons/bs";

import { connect } from "react-redux";
import { loginRequest } from "../redux/actions/auth";

export class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      showPassword: false,
      loading: false,
      loginAttempted: false,
      setError: "",
    };
  }

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleShowPasswordToggle = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  };

  handleLogin = () => {
    this.setState({ loading: true, loginAttempted: true });
    if (this.state.email && this.state.password) {
      this.props.logUserIn(this.state)
        .then(() => {
          this.setState({ loading: false });
        })
        .catch(() => {
          this.setState({ setError: "Email and Password Combination Required", loading: false });
        });
    } else {
      this.setState({ setError: "Email and Password Combination Required", loading: false });
    }
  };
  

  render() {
    const { error, loggingIn, loggedIn } = this.props.auth;

    return (
      <div>
        <div className="d-flex align-items-center auth px-0">
          <div className="row w-100 mx-0">
            <div className="col-lg-4 mx-auto">
              <div className="card text-left py-5 px-4 px-sm-5">
                <div className="brand-logo">
                  <img
                    src={require("../../assets/images/logo.png")}
                    alt="logo"
                  />
                </div>
                <h4>Hello! let's get started</h4>
                <h6 className="font-weight-light">
                  Sign in as a Delivery-Connect Provider.
                </h6>
                <Form className="pt-3">
                  <Form.Group className="d-flex search-field">
                    <Form.Control
                      onChange={this.handleInput}
                      name="email"
                      value={this.state.email}
                      type="email"
                      placeholder="Company Email"
                      size="lg"
                      className="h-auto"
                    />
                  </Form.Group>
                  <Form.Group className="d-flex search-field">
                    <div
                      className=""
                      style={{ width: "100%", position: "relative" }}
                    >
                      <Form.Control
                        onChange={this.handleInput}
                        name="password"
                        value={this.state.password}
                        type={this.state.showPassword ? "text" : "password"}
                        placeholder="Password"
                        size="lg"
                        className="h-auto mb-3"
                      />
                      {this.state.showPassword ? (
                        <BsEyeSlash
                          onClick={this.handleShowPasswordToggle}
                          style={{
                            cursor: "pointer",
                            right: 0,
                            top: 10,

                            color: "",
                          }}
                          className="position-absolute text-primary    m-2"
                        />
                      ) : (
                        <BsEye
                          onClick={this.handleShowPasswordToggle}
                          style={{
                            cursor: "pointer",
                            right: 0,
                            top: 10,

                            color: "",
                          }}
                          className="position-absolute text-primary    m-2"
                        />
                      )}
                    </div>
                  </Form.Group>
                  <div className="mt-3">
                    <Link
                      className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                      onClick={this.handleLogin}
                      to="#"
                      disabled={this.state.loading}
                    >
                      {this.state.loading ? "Loading..." : "SIGN IN"}
                    </Link>
                  </div>
                  <div className="mt-3">
                    {!this.state.loading &&
                    this.state.loginAttempted && 
                      error &&
                      !this.state.setError &&
                      !loggedIn &&
                      !loggingIn && <Alert variant="danger">{error}</Alert>}
                    {!this.state.loading &&
                      this.state.setError && <Alert variant="danger">{this.state.setError}</Alert>}
                  </div>
                  <div className="my-2 d-flex flex-wrap justify-content-between align-items-center">
                    <div className="form-check">
                      <label className="form-check-label text-muted">
                        <input type="checkbox" className="form-check-input" />
                        <i className="input-helper"></i>
                        Keep me signed in
                      </label>
                    </div>
                    <Link to="/reset-password" className="auth-link text-muted">
                      Forgot password?
                    </Link>
                  </div>
                  <div className="text-center mt-4 font-weight-light">
                    Not yet a Delivery-Connect Logistics Provider? Click here to{" "}
                    <Link to="/register" className="text-primary">
                      Register
                    </Link>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.authReducer,
});

function mapDispatchToProps(dispatch) {
  return {
    logUserIn: (data) => dispatch(loginRequest(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
